export const TERMS_INTRO =
  "I hereby confirm that I am voluntarily enrolling in the ADC Part 2 preparation course conducted by Overseas Dental Achiever\u2019s Academy (\u201cthe Academy\u201d). By signing this document, I agree to abide by the following terms and conditions:";

export const TERMS_SECTIONS = [
  {
    title: "1. Professional Conduct",
    bullets: [
      "I agree to maintain professional, respectful, and ethical behavior towards faculty members, staff, and fellow students at all times.",
      "Any misconduct, harassment, disruptive behavior, discrimination, intoxication, or inappropriate conduct may result in immediate termination from the course without refund.",
    ],
  },
  {
    title: "2. Care of Academy Property & Equipment",
    bullets: [
      "I understand that the Academy provides expensive dental equipment, instruments, manikins, materials, models, simulators, and other educational resources for training purposes.",
      "I agree to handle all equipment carefully and responsibly.",
      "Any intentional damage, negligence, misuse, theft, or unauthorized removal of Academy property may result in financial liability for repair or replacement costs.",
      "I agree to follow all infection control, sterilization, and safety protocols instructed by the Academy.",
    ],
  },
  {
    title: "3. Proprietary Educational Material & Confidentiality",
    bullets: [
      "I acknowledge that all teaching materials, presentations, notes, manuals, demonstrations, videos, techniques, structured exercises, mock exam formats, and educational content provided by the Academy are proprietary and confidential.",
      "I shall not copy, reproduce, record, distribute, upload, publish, share, sell, or circulate any Academy material without written permission.",
      "Photography, audio recording, or video recording of lectures, demonstrations, practical sessions, or Academy materials is prohibited unless specifically authorized.",
    ],
  },
  {
    title: "4. Non-Disclosure & Non-Compete Understanding",
    bullets: [
      "I agree not to use the Academy\u2019s proprietary teaching methods, materials, systems, mock exam structures, or confidential information for establishing, promoting, assisting, or conducting any competing ADC coaching or training program.",
      "I agree not to share confidential Academy information with other institutions, students outside the course, social media platforms, or third parties.",
    ],
  },
  {
    title: "5. Promotional Consent",
    bullets: [
      "I understand that photographs, videos, testimonials, classroom activities, practical sessions, or group photographs may occasionally be taken during the course for academic, educational, website, brochure, or promotional purposes.",
      "I grant permission to the Academy to use such photographs, videos, or testimonials for lawful promotional and marketing activities unless I specifically notify the Academy in writing otherwise.",
    ],
  },
  {
    title: "6. Attendance & Participation",
    bullets: [
      "Students are expected to attend all scheduled lectures, demonstrations, mock exams, and practical sessions punctually.",
      "The Academy reserves the right to deny certification or completion acknowledgment in cases of poor attendance or non-participation.",
    ],
  },
  {
    title: "7. Course Fees & Refund Policy",
    bullets: [
      "Course fees once paid are generally non-refundable and non-transferable unless otherwise approved by management under exceptional circumstances.",
      "The Academy reserves the right to reschedule batches, faculty, or course timings when necessary.",
    ],
  },
  {
    title: "8. Limitation of Responsibility",
    bullets: [
      "The Academy provides guidance and preparation support for ADC Part 2 examination; however, success in the examination cannot be guaranteed.",
      "The Academy shall not be held responsible for examination outcomes, visa matters, travel issues, accommodation arrangements, personal belongings, or individual licensing decisions by ADC authorities.",
    ],
  },
  {
    title: "9. Health & Safety",
    bullets: [
      "Students must follow all clinical safety instructions, infection control protocols, and workplace safety measures at all times.",
      "Students are responsible for informing the Academy about any relevant medical condition or restriction that may affect participation.",
    ],
  },
  {
    title: "10. Termination of Enrollment",
    bullets: [
      "The Academy reserves the right to suspend or terminate enrollment without refund if a student violates Academy rules, damages property, breaches confidentiality, engages in unethical conduct, or disrupts the learning environment.",
    ],
  },
];

export const DECLARATION_TEXT =
  "I confirm that I have read, understood, and agreed to all the above terms and conditions of Overseas Dental Achiever\u2019s Academy.";
